import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom'
import { LanguageContext } from '../Language/LanguageContext';
import { AlertModalContext } from '../Library/AlertModalContext'
import { HeaderTitle, Loading } from '../Library';
import { createDeliveryTrack, deliveryDetail, listDeliveryTrack, markAsDelivered, cancelDelivery, deleteDelivery } from '../Network/Delivery';
import { listCompany } from '../Network/Company'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle, faClock, faCheckCircle, faTimesCircle, faBox, faEnvelope, faTruck } from '@fortawesome/free-solid-svg-icons';
import { deliveryStatus, deliveryType } from './DeliveryStatusConstant'
import './DeliveryDetail.css'
import DatePicker from 'react-datepicker';
import { baseURL } from '../Network/Config'

function DeliveryDetail() {
    const history = useHistory()
    const alertModal = useContext(AlertModalContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.delivery
    const { deliveryId } = useParams()

    const [isLoading, setIsLoading] = useState(false)
    const [trackingNo, setTrackingNo] = useState("")
    const [sender, setSender] = useState("")
    const [senderAddress, setSenderAddress] = useState("")
    const [provider, setProvider] = useState("")
    const [senderDate, setSenderDate] = useState(new Date())
    const [receiveDate, setReceiveDate] = useState(new Date())
    const [type, setType] = useState({ text: lang.no_status, icon: faQuestionCircle, color: 'grey' })
    const [company, setCompany] = useState("")
    const [companyAddress, setCompanyAddress] = useState("")
    const [status, setStatus] = useState({ text: lang.no_status, icon: faQuestionCircle, color: 'grey', identifier: "NO_STATUS" })

    const [signature, setSignature] = useState(null)
    const [receiverUser, setReceiverUser] = useState(null)

    const [deliveryTrackList, setDeliveryTrackList] = useState([])
    const [toAddDetail, setToAddDetail] = useState("")
    const [toAddRemark, setToAddRemark] = useState("")
    const [toAddDate, setToAddDate] = useState(new Date())
    const [isErrorAdd, setIsErrorAdd] = useState(false)

    const DetailRow = ({ title, value }) => {
        return(
            <div className='col-detail'>
                <div style={{ flex: 0.4 }}>
                    <b>{`${title} : `}</b>
                </div>
                <div style={{ flex: 1 }}>
                    {value}
                </div>
            </div>
        )
    }

    const TrackItem = ({ title, remark, date, isLast, isCurrent }) => {
        return(
            <div className='track-item'>
                <div className='track-col-indicator'>
                    <div 
                    className='track-indicator'
                    style={{ backgroundColor: isCurrent ? 'orange': 'lightgray' }}/>
                    { !isLast ?
                    <div className='line'/>
                    : null
                    }
                </div>
                <div className='track-col-detail'>
                    <div className='title'>{title}</div>
                    <div className='remark'>{remark}</div>
                    <div className='date'>{dayjs(date).format("D MMMM YYYY H:mm")}</div>
                </div>
            </div>
        )
    }

    const fetchData = () => {
        setIsLoading(true)
        deliveryDetail(deliveryId,
            (data) => {
                console.log(data)
                setTrackingNo(data.trackingNo)
                setSender(data.senderName)
                setSenderAddress(data.senderAddress)
                setProvider(data.provider)
                setSenderDate(data.senderDate)
                setReceiveDate(data.receiveDate)
                setCompany(data.company.name)
                setCompanyAddress(data.company.location)
                setSignature(data.signaturePath)
                setReceiverUser(data.receiver_user)
                switch (data.status) {
                    case deliveryStatus.WAITING:
                        setStatus({ icon: faClock, color: 'orange', text: lang.waiting, color: 'orange',identifier: deliveryStatus.WAITING })
                        break;
                    case deliveryStatus.DELIVERED:
                        setStatus({ icon: faClock, color: 'green', text: lang.delivered, color: 'rgb(58, 136, 188)', identifier: deliveryStatus.DELIVERED })
                        break
                    case deliveryStatus.COMPLETE:
                        setStatus({ icon: faCheckCircle, color: 'green', text: lang.complete, color: 'green', identifier: deliveryStatus.COMPLETE })
                        break
                    case deliveryStatus.CANCELLED:
                        setStatus({ icon: faTimesCircle, color: 'red', text: lang.cancel, color: 'red', identifier: deliveryStatus.CANCELLED })
                        break
                    default:
                        setStatus({ icon: faQuestionCircle, color: 'grey', text: lang.no_status, color: 'grey', identifier: "NO_STATUS" })
                        break;
                }

                switch (data.type) {
                    case deliveryType.PARCEL:
                        setType({ icon: faBox, color: 'brown', text: lang.parcel })
                        break;
                    case deliveryType.MAIL:
                        setType({ icon: faEnvelope, color: '#10B0F6', text: lang.mail })
                        break;
                    default:
                        setType({ icon: faQuestionCircle, color: 'grey', text: lang.no_status, color: 'grey' })
                        break;
                }

                setIsLoading(false)
            },
            (error) => {
                setIsLoading(false)
            })
    }
    const fetchTrackData = () => {
        listDeliveryTrack(deliveryId,
            (data) => {
                setDeliveryTrackList(data)
            },
            (error) => {  })
    }

    const addTrackingDelivery = () => {
        if(!toAddDetail){
            setIsErrorAdd(true)
            return
        }

        setIsLoading(true)
        createDeliveryTrack(deliveryId, toAddDetail, toAddRemark, toAddDate,
            ()=>{
                fetchTrackData()
                setToAddDetail("")
                setToAddRemark("")
                setIsLoading(false)
            },
            (error) => {  })
    }

    const delivered = () => {
        alertModal.setTitle(lang.mark_delivered)
        alertModal.setDescription(lang.are_you_sure_to_delivered)
        alertModal.setAlertType("WARNING")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "primary",
                onClick: ()=>{ 
                    setIsLoading(true)
                    markAsDelivered(deliveryId,
                        ()=>{
                            fetchData()
                            fetchTrackData()
                        },
                        (error) => {  }
                    )

                    alertModal.setIsShow(false)
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
    }

    const onCancelDelivery = () => {
        alertModal.setTitle(lang.cancel_delivery)
        alertModal.setDescription(lang.are_you_sure_to_cancel)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                    setIsLoading(true)
                    cancelDelivery(deliveryId,
                        ()=>{
                            fetchData()
                            fetchTrackData()
                        },
                        (error)=>{

                        })

                    alertModal.setIsShow(false)
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
    }

    const onDeleteDelivery = () => {
        alertModal.setTitle(lang.delete_delivery)
        alertModal.setDescription(lang.are_you_sure_to_delete)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                    setIsLoading(true)
                    deleteDelivery(deliveryId,
                        ()=>{
                            history.push('/delivery')
                        },
                        (error)=>{

                        })

                    alertModal.setIsShow(false)
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
    }

    useEffect(()=>{
        fetchData()
        fetchTrackData()
    },[])

    return (
        <div id="delivery-detail">
            { isLoading ? <Loading/> : null }
            <HeaderTitle 
            title={
                <div>
                    <FontAwesomeIcon 
                    icon={type.icon}
                    style={{color: type.color, marginRight: 15}}/>
                    {trackingNo}
                </div>
            }
            isShowBack
            backTo="/delivery"/>
            <Row>
                <Col md={6}>
                    <div style={{ marginBottom: 23 }}>
                        <DetailRow 
                        title={lang.status} 
                        value={
                            <div>
                                <FontAwesomeIcon icon={status.icon} color={status.color} style={{ marginRight: 8 }}/>
                                {status.text}
                            </div>
                        }/>
                        <DetailRow title={lang.type} value={type.text}/>
                        <DetailRow title={lang.tracking_no} value={trackingNo}/>
                        <DetailRow title={lang.sender} value={sender}/>
                        <DetailRow title={lang.sender_address} value={senderAddress}/>
                        <DetailRow title={lang.provider} value={provider}/>
                        <DetailRow title={lang.sender_date} value={dayjs(senderDate).format("D MMMM YYYY")}/>
                        <DetailRow title={lang.estimate_receive_date} value={dayjs(receiveDate).format("D MMMM YYYY")}/>
                        <DetailRow title={lang.company_receive} value={company}/>
                        <DetailRow title={lang.company_address} value={companyAddress}/>
                    </div>

                    <div>
                        <div className="col-title">{lang.delivery_detail}</div>
                        <div style={{ marginTop: 18 }}>
                            { deliveryTrackList.map((item, key) =>
                                <TrackItem 
                                key={key}
                                title={item.deliveryDetail} 
                                remark={item.remark} 
                                date={item.date}
                                isCurrent={key === deliveryTrackList.length - 1 ? true : false}
                                isLast={key === deliveryTrackList.length - 1 ? true : false}
                                />
                            )}
                        </div>
                    </div>

                </Col>
                <Col md={6}>
                    { status.identifier === deliveryStatus.WAITING ?
                    <div className='action-group'>
                        <div className='col-title'>{lang.mark_delivered}</div>
                        <div className='col-desc'>{lang.mark_delivered_desc}</div>
                        <div className='col-btn'>
                            <Button variant='success' onClick={()=>delivered()}>
                                {lang.mark_delivered}
                            </Button>
                        </div>
                    </div>
                    : null
                    }
                    { status.identifier === deliveryStatus.COMPLETE ?
                    <div className='action-group'>
                        <div className='col-title'>{lang.signature_receiver}</div>
                        <div className='col-desc'>{lang.signature_receiver_desc}</div>
                        
                        <div className='signature'>
                            <img src={`${baseURL}${signature}`}/> 
                        </div>

                        <div style={{ marginTop: 13 }}><b>{lang.receiver} : </b>{`${receiverUser.firstName} ${receiverUser.lastName}`}</div>
                        <div><b>{lang.email} : </b>{`${receiverUser.email}`}</div>
                        <div><b>{lang.position} : </b>{`${receiverUser.position} ${receiverUser.lastName}`}</div>
                   </div>
                    : null
                    }
                    { status.identifier === deliveryStatus.DELIVERED ?
                    <div className='action-group'>
                        <div className='col-title'>{lang.please_notify_as_delivered}</div>
                        <div className='col-desc'>{lang.please_notify_as_delivered_desc}</div>
                    </div>
                    : null
                    }
                    { status.identifier !== deliveryStatus.CANCELLED && status.identifier !== deliveryStatus.COMPLETE ?
                    <div className='action-group'>
                        <div className='col-title'>{lang.add_track_detail}</div>
                        <div className='col-desc'>{lang.add_track_detail_desc}</div>
                        <Form
                        onSubmit={(e)=>{
                            e.preventDefault()
                            addTrackingDelivery()
                        }}
                        >
                            <Form.Control
                            placeholder={lang.detail}
                            value={toAddDetail}
                            isInvalid={isErrorAdd && !toAddDetail}
                            onChange={(e)=>setToAddDetail(e.target.value)}
                            style={{ marginTop: 13 }}/>
                            <Form.Control 
                            placeholder={lang.remark}
                            value={toAddRemark}
                            onChange={(e)=>setToAddRemark(e.target.value)}
                            style={{ marginTop: 13 }}/>
                            <div style={{ marginTop: 13 }}>
                                <DatePicker
                                className='form-control'
                                selected={toAddDate}
                                dateFormat="d MMMM yyyy H:mm"
                                showTimeSelect
                                onChange={(date)=>setToAddDate(date)}
                                />
                            </div>

                            <div className='col-btn'>
                                <Button variant='primary' type='submit'>
                                    {lang.add}
                                </Button>
                            </div>
                        </Form>
                        
                    </div>
                    : null
                    }
                    { status.identifier === deliveryStatus.WAITING || status.identifier === deliveryStatus.DELIVERED ?
                    <div className='action-group'>
                        <div className='col-title'>{lang.edit_delivery}</div>
                        <div className='col-desc'>{lang.edit_delivery_desc}</div>
                        <div className='col-btn'>
                            <Button variant='primary' onClick={()=>history.push(`/delivery/edit/${deliveryId}`)}>
                                {lang.edit_delivery}
                            </Button>
                        </div>
                    </div>
                    : null
                    }
                    { status.identifier !== deliveryStatus.CANCELLED && status.identifier !== deliveryStatus.COMPLETE ?
                    <div className='action-group'>
                        <div className='col-title'>{lang.cancel_delivery}</div>
                        <div className='col-desc'>{lang.cancel_delivery_desc}</div>
                        <div className='col-btn'>
                            <Button variant='danger' onClick={()=>onCancelDelivery()}>
                                {lang.cancel_delivery}
                            </Button>
                        </div>
                    </div>
                    : null
                    }
                    <div className='action-group'>
                        <div className='col-title'>{lang.delete_delivery}</div>
                        <div className='col-desc'>{lang.delete_delivery_desc}</div>
                        <div className='col-btn'>
                            <Button variant='danger' onClick={()=>onDeleteDelivery()}>
                                {lang.delete_delivery}
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>

    )
}

export default DeliveryDetail;
